import * as React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${(props) => props.theme.pallet.primary};
  color: #fff;
  box-shadow: ${(props) => props.theme.ui.boxShadow};
  margin-bottom: 3px;

  .sky-line {
    position: absolute;
    bottom: 0;
    width: 100%;
    opacity: 0.1;
  }

  span {
    display: flex;
    align-items: center;

    h1 {
      font-size: 1.8rem;
      margin-left: 8px;
    }
  }
`;

export default () => (
  <Container>
    {/*
    <img
      src='/assets/new-york-skyline-clean.png'
      alt='New York Skyline Outline'
      className="sky-line"
    />  
    */}
    <img
      style={{
        width: "200px",
        height: "auto",
        display: "block",
      }}
      src="/assets/spectacles-logo.svg"
      alt="Spectacles Logo"
    />
  </Container>
);
